import { render, staticRenderFns } from "./addCoupons.vue?vue&type=template&id=56cf0d87&scoped=true&"
import script from "./addCoupons.vue?vue&type=script&lang=js&"
export * from "./addCoupons.vue?vue&type=script&lang=js&"
import style0 from "./addCoupons.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./addCoupons.vue?vue&type=style&index=1&id=56cf0d87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cf0d87",
  null
  
)

component.options.__file = "addCoupons.vue"
export default component.exports